import CryptoJS from "crypto-js";

// Helper to access environment variables safely in both Vite (client) and Node environments
const getEnvVar = (key: string): string => {
    // Check for Vite's import.meta.env
    try {
        // @ts-ignore
        if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
            // @ts-ignore
            return import.meta.env[key];
        }
    } catch (e) {
        // Ignore errors accessing import.meta
    }

    // Check for Node's process.env
    try {
        // @ts-ignore
        if (typeof process !== 'undefined' && process.env && process.env[key]) {
            // @ts-ignore
            return process.env[key];
        }
    } catch (e) {
        // Ignore reference errors
    }

    return "";
};

const SECRET_KEY = getEnvVar("VITE_ENCRYPTED_SECRET_KEY");

export class ReactCipher {
    static encrypt(data: any) {
        if (!data) return null;
        if (!SECRET_KEY) {
            console.warn("ReactCipher: VITE_ENCRYPTED_SECRET_KEY is missing");
            return null;
        }
        return CryptoJS.AES.encrypt(String(data), SECRET_KEY).toString();
    }
}